import { AlkLogger } from '@alk/core';
import { AUTHENTICATION_FACTORY, IAuthenticationFactory } from '../authentication';
import { filter, pluck } from 'rxjs/operators';
import { IBackendSessionService } from './backend-session.interface';
import { inject, injectable } from 'inversify';
import { ISessionAdapterService, SESSION_ADAPTER_SERVICE } from '../message-adapters/session-adapter';
import { ISessionMessageState } from '../../interfaces';

@injectable()
export class BackendSessionService implements IBackendSessionService {

    @inject(SESSION_ADAPTER_SERVICE) private readonly sessionSrv: ISessionAdapterService;
    @inject(AUTHENTICATION_FACTORY) private readonly authFactory: IAuthenticationFactory;

    synchronize(): void {
        AlkLogger.info('[BackendSessionService#synchronize]');

        this.sessionSrv.sessionObservable()
            .pipe(
                pluck('state'),
                filter((state: ISessionMessageState) => state === 'end'),
            ).subscribe(() => {
                AlkLogger.info('[BackendSessionService#synchronize] Session will end !');

                sessionStorage.setItem('IS_BACKEND_LOGOUT', 'true');

                const authSrv = this.authFactory();
                authSrv.logout();
            });
    }
}
